<template>
    <div>
        <n-building-detail></n-building-detail>
        <n-income></n-income>
        <div class="row">
            <div class="col-6">
                <n-todo></n-todo>
            </div>
        </div>
    </div>
</template>
<script>
    import NBuildingDetail from '@/partials/income/building_detail';
    import NIncome from '@/partials/income/income';
    import NTodo from '@/partials/income/todo';

    export default {

        components: {
            NBuildingDetail, NIncome, NTodo
        }
    }
</script>
